<template>
  <div class="account-combined-login">
    <account-login></account-login>
    <account-login-footer></account-login-footer>
  </div>
</template>
<script src="./account-combined-login.js"></script>
